import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideTranslateCompiler } from '@ngx-translate/core';
import { createErrorHandler } from '@sentry/angular';
import { MESSAGE_FORMAT_CONFIG, TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import { apiInterceptor } from '~api/openapi/api.interceptor';
import { appLocalization } from '~app/app.localization';
import { ConfigService } from '~app/services/config.service';
import { AppConfig } from '~app/types/app-config';
import { routes } from './app.routes';

export function ApplicationConfigFactory(config: AppConfig): ApplicationConfig {
  return {
    providers: [
      ConfigService.provide(config),
      appLocalization.provideEnvironment({
        compiler: provideTranslateCompiler(TranslateMessageFormatCompiler),
      }),
      {
        provide: MESSAGE_FORMAT_CONFIG,
        useValue: { locales: appLocalization.supportedLanguages }
      },
      provideBrowserGlobalErrorListeners(),
      provideZoneChangeDetection({ eventCoalescing: true }),
      provideRouter(routes),
      provideHttpClient(withInterceptors([apiInterceptor])),
      {
        provide: ErrorHandler,
        useValue: createErrorHandler()
      }
    ]
  };
}
